import * as Yup from 'yup'

const revenueTransferScheme = Yup.object().shape({
  amount                        : Yup.string().required('amount required'),
  receiving_bank                : Yup.string().required('recieving bank required'),
  receiving_bank_account_name   : Yup.string().required('recieving bank account name required'),
  receiving_bank_account_number : Yup.string().required('recieving bank account number required'),
  notes                         : Yup.string().required('notes required')

})

export default revenueTransferScheme
